import React, {Component} from 'react';
import {Card, Col, Container, Row} from "react-bootstrap";
import image from "../../images/D02.jpg"

class About extends Component {
    render() {
        return (
            <div>
                <Container style={{
                    marginTop: '20px'
                }}>
                    <Row>
                        <Col sm={4}>
                            <Card>
                                <Card.Img src={image}/>
                            </Card>
                        </Col>
                        <Col>
                            <h5>
                                Welcome to the searchable database of High Impact engagement opportunities at UIC! You
                                can find activities tailored to your interests and your progress at the university. Use
                                the search bar or field specific drop down menus to customize your search and search
                                results. For questions about opportunities, please contact the department listed in the
                                contact tab. For any questions about the database, please email <a
                                href="uicimpact@uic.edu">uicimpact@uic.edu</a>.
                            </h5>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/components/about/About.js